import { render, staticRenderFns } from "./Academics.vue?vue&type=template&id=14d7bf78&scoped=true&"
import script from "./Academics.vue?vue&type=script&lang=js&"
export * from "./Academics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d7bf78",
  null
  
)

export default component.exports